import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "../../../shared/services/app.service";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Serializer} from '../../../shared/interfaces/serializer';
import {SavedReportFolder} from '../../../shared/interfaces/saved-report-folder';

@Component({
  selector: 'app-dialog-new-report',
  templateUrl: './dialog-new-report.component.html',
  styleUrls: ['./dialog-new-report.component.scss']
})
export class DialogNewReportComponent implements OnInit {

  constructor(
    private readonly appS: AppService,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { folder?: Serializer<SavedReportFolder> },
    private readonly dialogRef: MatDialogRef<DialogNewReportComponent>
  ) { }

  ngOnInit(): void {}

  public templateNavigate() {
    this.router.navigate([`/${this.appS.datasetID}/new-report`], { queryParams: { state: 'templates', folder: this._data.folder?.id }});
    this.dialogRef.close();
  }

  public emptyNavigate() {
    this.router.navigate([`/${this.appS.datasetID}/new-report`], { queryParams: { state: 'empty', folder: this._data.folder?.id }});
    this.dialogRef.close();
  }

}
